module.exports = __webpack_public_path__ + "static/media/google-login.dbccc483.webp";